import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { ApiKeyCredentials } from "./apiKeyCredentials";
/**
 * A {@link TopicCredentials} object used for Azure Event Grid.
 */

export var TopicCredentials = /*#__PURE__*/function (_ApiKeyCredentials) {
  _inherits(TopicCredentials, _ApiKeyCredentials);

  /**
   * Creates a new EventGrid TopicCredentials object.
   *
   * @param topicKey - The EventGrid topic key
   */
  function TopicCredentials(topicKey) {
    _classCallCheck(this, TopicCredentials);

    if (!topicKey || topicKey && typeof topicKey !== "string") {
      throw new Error("topicKey cannot be null or undefined and must be of type string.");
    }

    var options = {
      inHeader: {
        "aeg-sas-key": topicKey
      }
    };
    return _possibleConstructorReturn(this, _getPrototypeOf(TopicCredentials).call(this, options));
  }

  return TopicCredentials;
}(ApiKeyCredentials);